const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 200, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 150, flex: 1 },
  { field: "tempHeladaIn", headerName: "Temp Helada In", minWidth: 150, flex: 1 },
  { field: "tempHeladaOut", headerName: "Temp Helada Out", minWidth: 150, flex: 1 },
  { field: "tempCondensacionIn", headerName: "Temp Condensacion In", minWidth: 150, flex: 1 },
  { field: "tempCondensacionOut", headerName: "Temp Condensacion Out", minWidth: 150, flex: 1 },
  { field: "presSuccion1", headerName: "Pres Succion 1", minWidth: 150, flex: 1 },
  { field: "presSuccion2", headerName: "Pres Succion 2", minWidth: 150, flex: 1 },
  { field: "presSuccion3", headerName: "Pres Succion 3", minWidth: 150, flex: 1 },
  { field: "presSuccion4", headerName: "Pres Succion 4", minWidth: 150, flex: 1 },
  { field: "presDescarga1", headerName: "Pres Descarga 1", minWidth: 150, flex: 1 },
  { field: "presDescarga2", headerName: "Pres Descarga 2", minWidth: 150, flex: 1 },
  { field: "presDescarga3", headerName: "Pres Descarga 3", minWidth: 150, flex: 1 },
  { field: "presDescarga4", headerName: "Pres Descarga 4", minWidth: 150, flex: 1 },
  { field: "presDiferencialAceite1", headerName: "Pres Diferencial de Aceite 1", minWidth: 200, flex: 1 },
  { field: "presDiferencialAceite2", headerName: "Pres Diferencial de Aceite 2", minWidth: 200, flex: 1 },
  { field: "presDiferencialAceite3", headerName: "Pres Diferencial de Aceite 3", minWidth: 200, flex: 1 },
  { field: "presDiferencialAceite4", headerName: "Pres Diferencial de Aceite 4", minWidth: 200, flex: 1 },
  { field: "lugarLeadLagComp1", headerName: "Lugar LeadLag Comp 1", minWidth: 150, flex: 1 },
  { field: "lugarLeadLagComp2", headerName: "Lugar LeadLag Comp 2", minWidth: 150, flex: 1 },
  { field: "lugarLeadLagComp3", headerName: "Lugar LeadLag Comp 3", minWidth: 150, flex: 1 },
  { field: "lugarLeadLagComp4", headerName: "Lugar LeadLag Comp 4", minWidth: 150, flex: 1 },
  { field: "habilitaCompresor1", headerName: "Habilita Compresor 1", minWidth: 150, flex: 1 },
  { field: "habilitaCompresor2", headerName: "Habilita Compresor 2", minWidth: 150, flex: 1 },
  { field: "habilitaCompresor3", headerName: "Habilita Compresor 3", minWidth: 150, flex: 1 },
  { field: "habilitaCompresor4", headerName: "Habilita Compresor 4", minWidth: 150, flex: 1 },
  { field: "estatusCompresor1", headerName: "Estatus Compresor 1", minWidth: 150, flex: 1 },
  { field: "estatusCompresor2", headerName: "Estatus Compresor 2", minWidth: 150, flex: 1 },
  { field: "estatusCompresor3", headerName: "Estatus Compresor 3", minWidth: 150, flex: 1 },
  { field: "estatusCompresor4", headerName: "Estatus Compresor 4", minWidth: 150, flex: 1 },
  { field: "flujoAguaHelada", headerName: "Flujo Agua Helada", minWidth: 150, flex: 1 },
  { field: "flujoAguaCondensador", headerName: "Flujo Agua Condensador", minWidth: 150, flex: 1 },
  { field: "arranqueRemoto", headerName: "Arranque Remoto", minWidth: 150, flex: 1 },
  { field: "encendidoCompresor1", headerName: "Encendido Compresor 1", minWidth: 150, flex: 1 },
  { field: "encendidoCompresor2", headerName: "Encendido Compresor 2", minWidth: 150, flex: 1 },
  { field: "encendidoCompresor3", headerName: "Encendido Compresor 3", minWidth: 150, flex: 1 },
  { field: "encendidoCompresor4", headerName: "Encendido Compresor 4", minWidth: 150, flex: 1 },
  { field: "bombaAlberca", headerName: "Bomba Alberca", minWidth: 150, flex: 1 },
  { field: "output05", headerName: "Output_05", minWidth: 150, flex: 1 },
  { field: "output06", headerName: "Output_06", minWidth: 150, flex: 1 },
  { field: "output07", headerName: "Output_07", minWidth: 150, flex: 1 },
  { field: "output08", headerName: "Output_08", minWidth: 150, flex: 1 },
  { field: "output09", headerName: "Output_09", minWidth: 150, flex: 1 },
  { field: "output10", headerName: "Output_10", minWidth: 150, flex: 1 },
  { field: "output11", headerName: "Output_11", minWidth: 150, flex: 1 },
  { field: "output12", headerName: "Output_12", minWidth: 150, flex: 1 },
  { field: "output13", headerName: "Output_13", minWidth: 150, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla1", headerName: "Numero de Falla 1", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla2", headerName: "Numero de Falla 2", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla3", headerName: "Numero de Falla 3", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla4", headerName: "Numero de Falla 4", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla5", headerName: "Numero de Falla 5", minWidth: 150, flex: 0.5 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempHeladaIn: row["Temp Helada In"],
  tempHeladaOut: row["Temp Helada Out"],
  tempCondensacionIn: row["Temp Condensacion In"],
  tempCondensacionOut: row["Temp Condensacion Out"],
  presSuccion1: row["Pres Succion 1"],
  presSuccion2: row["Pres Succion 2"],
  presSuccion3: row["Pres Succion 3"],
  presSuccion4: row["Pres Succion 4"],
  presDescarga1: row["Pres Descarga 1"],
  presDescarga2: row["Pres Descarga 2"],
  presDescarga3: row["Pres Descarga 3"],
  presDescarga4: row["Pres Descarga 4"],
  presDiferencialAceite1: row["Pres Diferencial de Aceite 1"],
  presDiferencialAceite2: row["Pres Diferencial de Aceite 2"],
  presDiferencialAceite3: row["Pres Diferencial de Aceite 3"],
  presDiferencialAceite4: row["Pres Diferencial de Aceite 4"],
  lugarLeadLagComp1: row["Lugar LeadLag Comp 1"],
  lugarLeadLagComp2: row["Lugar LeadLag Comp 2"],
  lugarLeadLagComp3: row["Lugar LeadLag Comp 3"],
  lugarLeadLagComp4: row["Lugar LeadLag Comp 4"],
  habilitaCompresor1: row["Habilita Compresor 1"],
  habilitaCompresor2: row["Habilita Compresor 2"],
  habilitaCompresor3: row["Habilita Compresor 3"],
  habilitaCompresor4: row["Habilita Compresor 4"],
  estatusCompresor1: row["Estatus Compresor 1"],
  estatusCompresor2: row["Estatus Compresor 2"],
  estatusCompresor3: row["Estatus Compresor 3"],
  estatusCompresor4: row["Estatus Compresor 4"],
  flujoAguaHelada: row["Flujo Agua Helada"],
  flujoAguaCondensador: row["Flujo Agua Condensador"],
  arranqueRemoto: row["Arranque Remoto"],
  encendidoCompresor1: row["Encendido Compresor 1"],
  encendidoCompresor2: row["Encendido Compresor 2"],
  encendidoCompresor3: row["Encendido Compresor 3"],
  encendidoCompresor4: row["Encendido Compresor 4"],
  bombaAlberca: row["Bomba Alberca"],
  output05: row["Output_05"],
  output06: row["Output_06"],
  output07: row["Output_07"],
  output08: row["Output_08"],
  output09: row["Output_09"],
  output10: row["Output_10"],
  output11: row["Output_11"],
  output12: row["Output_12"],
  output13: row["Output_13"],
  fechaFalla1: row["Fecha de Falla 1"],
  numeroFalla1: row["Numero de Falla 1"],
  fechaFalla2: row["Fecha de Falla 2"],
  numeroFalla2: row["Numero de Falla 2"],
  fechaFalla3: row["Fecha de Falla 3"],
  numeroFalla3: row["Numero de Falla 3"],
  fechaFalla4: row["Fecha de Falla 4"],
  numeroFalla4: row["Numero de Falla 4"],
  fechaFalla5: row["Fecha de Falla 5"],
  numeroFalla5: row["Numero de Falla 5"],
});

export const cotherm4compConsultaConfig = {
  title: "COTHERM 4 COMP",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/cotherm4comp/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "CoTherm 4Comp",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};